module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "460",
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.appointmentId && _vm.relationshipId) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "flat": "",
            "loading": _vm.request.loading,
            "disabled": _vm.disabled
          }
        }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(_vm.cta) + "\n    ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-1"
  }, [_vm._v("\n          Please confirm\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pa-0"
  }, [_vm._v("\n            These codes will automatically be added to new appointments\n          ")]), _vm._v("\n          For "), _c('strong', [_vm._v(_vm._s(_vm.clientName))]), _vm._v(" with "), _c('strong', [_vm._v(_vm._s(_vm.practitionerName))]), _c('br'), _vm._v("\n          for new appointments after\n          "), (_vm.startDate) ? _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.startDate)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stopDate) ? [_vm._v(" until "), (_vm.stopDate) ? _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.stopDate)
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-1"
  }, [_vm._v("Apply to all new appointments: ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    class: {
      'blue lighten-4': (_vm.dateFocus === 'start')
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "readonly": "",
      "label": "Created after",
      "value": _vm.startDate
    },
    on: {
      "click": function($event) {
        _vm.dateFocus = "start"
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    class: {
      'blue lighten-4': (_vm.dateFocus === 'stop')
    },
    attrs: {
      "box": "",
      "readonly": "",
      "hide-details": "",
      "clearable": "",
      "placeholder": "Until forever",
      "label": "Until (leave blank for forever)",
      "value": _vm.stopDate
    },
    on: {
      "click": function($event) {
        _vm.dateFocus = "stop"
      },
      "click:clear": function($event) {
        _vm.stopDate = null
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.dateFocus === "start") ? _c('v-subheader', {
    staticClass: "overline pl-1"
  }, [_vm._v("Choose a start date on the calendar")]) : _vm._e(), _vm._v(" "), (_vm.dateFocus === "stop") ? _c('v-subheader', {
    staticClass: "overline pl-1"
  }, [_vm._v("Choose a stop date on the calendar")]) : _vm._e(), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "flat": "",
      "full-width": "",
      "min": _vm.calMin,
      "max": _vm.calMax
    },
    on: {
      "change": _vm.dateSelected
    },
    model: {
      value: (_vm.startStopDate),
      callback: function($$v) {
        _vm.startStopDate = $$v
      },
      expression: "startStopDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout')], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.setCodes
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "success"
    }
  }, [_vm._v("check_circle")]), _vm._v("\n          Auto-codes have been added to this client\n        ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.request.result) ? _c('v-card-text', [_c('div', [_vm._v(_vm._s(_vm.request.result.description))]), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("Codes")]), _vm._v(" "), _c('div', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.request.result.codes_formatted)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false;
        _vm.step = 0
      }
    }
  }, [_vm._v("Done")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "caption pl-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n          You can manage auto-codes for a client from the client detail page on the \"codes\" tab\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba9e0db6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/CloneAppointmentCodes.vue
// module id = 1514
// module chunks = 9